/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps, react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import eventImage from "../../../../assets/images/eventImages/eventImage.jpg";

import { useNavigate, useParams } from "react-router-dom";
import { useCreateEventContext } from "../../../../context/CreateEventContext";
import ModalLoadingState from "../../../PopUpModal/ModalLoadingState";
import { useAuth } from "../../../../context/AuthContext";
import { getMPSBusinessDetails } from "../../../../firebaseFunctions/getMPSBusinessDetails/getBusinessDetails";
import companyLogoDefault from "../../../../assets/images/eventImages/companyLogo.jpg";
import document_icon from "../../../../assets/images/upload_document.svg";
import SocialMediaHandles from "../../../SocialMediaHandles/SocialMediaHandles";

const MyDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const eventId = useParams();
  // const eventId = selectedEvent;
  const [isLoading, setIsLoading] = useState(true);
  const { getEventData, eventData } = useCreateEventContext();
  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    if (eventId.id) {
      const fetchEvent = async () => {
        setIsLoading(true);
        try {
          const event = await getEventData(eventId.id);
        } catch (error) {
          console.log("error fetching event", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchEvent();
    }
  }, [eventId.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleBack = () => {
    console.log("back");
    navigate("/");
  };
  const handleApplyToEvent = () => {
    console.log("applyToEvent");
    navigate("/mps/event-registration/" + eventId.id);
  };

  const user = useAuth();
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (user?.user?.uid) {
        try {
          const userDetails = await getMPSBusinessDetails(user?.user?.uid);
          setUserDetails(userDetails);
        } catch (error) {
          console.error("Error fetching user details:", error);
        }
      }
    };

    fetchUserDetails();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const details = [
    {
      label: t('mpsDetails.businessName'),
      value: userDetails?.businessName,
    },
    {
      label: t('mpsDetails.businessType'),
      value: userDetails?.typeOfBusiness,
    },
    {
      label: t('mpsDetails.primaryContact'),
      value: userDetails?.fullName,
    },
    {
      label: t('mpsDetails.businessPhone'),
      value: userDetails?.phoneNumber,
    },
    {
      label: t('mpsDetails.emailAddress'),
      value: userDetails?.email,
    },
    {
      label: t('mpsDetails.smsContact'),
      value: userDetails?.phoneNumber,
    },
  ];

  return (
    <>
      {isLoading ? (
        <ModalLoadingState />
      ) : (
        <div className="w-full p-6">
          <p className="pl-1 pr-1 sm:pr-8 sm:pl-8 text-xl font-medium text-grey-900">
            {t('mpsDetails.myDetails')}
          </p>
          <div>
            <div className="my-8 mb-12">
              <p className="text-md text-grey-900 font-medium">{t('settings.companyLogo')}</p>
              <img
                src={userDetails?.companyLogo || companyLogoDefault}
                className="rounded-xl h-[104px] w-[104px] mt-2"
                alt=""
              />
            </div>
            <div className="w-2/3 grid grid-cols-2 gap-4">
              {details.map((detail, index) => (
                <div key={index} className="mb-4">
                  <label className="block text-base font-medium text-grey-900 whitespace-nowrap">
                    {detail.label}
                  </label>
                  <p className="text-sm font-normal mt-1">{detail.value}</p>
                </div>
              ))}
            </div>
            <div className="w-3/4 border-t border-gray-300 my-12" />
            <div>
              <p className="text-md text-grey-900 font-medium">{t('eventDetails.aboutLabel')}</p>
              <p className="text-sm font-normal mt-1">
                {userDetails?.description}
              </p>
            </div>
            <div className="w-3/4 border-t border-gray-300 my-6" />
            <div>
              <p className="text-md text-grey-900 font-medium">
                {" "}
                {t('mpsDetails.businessDocuments')}
              </p>
              <div className="w-full grid grid-cols-2 gap-4">
                {userDetails?.documents?.map((document, index) => (
                  <div
                    key={index}
                    className="border border-grey-300 rounded-2xl p-8 flex flex-col items-center justify-center"
                  >
                    <img
                      src={document_icon}
                      alt=""
                      className="h-[40px] w-[40px]"
                    />
                    <p className="pt-2 text-sm font-medium text-success-700 whitespace-nowrap">
                      {document?.fileName.length > 15
                        ? `${document.fileName.slice(0, 15)}...`
                        : document.fileName}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-1/2 pt-6 grid grid-cols-2 gap-4">
              <div>
                <p className="text-md text-grey-900 font-medium pt-4">
                  {t('eventDetails.websiteLabel')}
                </p>
                <p className="pt-1 text-sm text-grey-700 font-normal">
                  {userDetails?.website}
                </p>
              </div>
              <div>
                <p className="text-md text-grey-900 font-medium pt-4">
                  {t('eventDetails.socialMediaLabel')}
                </p>
                {userDetails?.socialMediaLink && (
                  <SocialMediaHandles handles={userDetails?.socialMediaLink} />
                )}
              </div>
            </div>
            {/* <div className="mt-4">
                            <p className="text-md text-grey-900 font-medium"> Additional Questions</p>
                        </div>
                        <div className="mt-4">
                            <p className="text-md text-grey-900 font-medium"> Extra Information</p>
                        </div>
                        <div className="flex items-center justify-end gap-4 pt-4">
                            <button className="max-w-[158px] justify-center text-grey-900 rounded-md underline px-3 py-2 mt-4 text-xs font-semibold transition duration-150 ease-in-out">
                                Withdraw Application
                            </button>
                            <button className="max-w-[158px] justify-center text-grey-900 rounded-md border border-grey-300 hover:border-primary-500 px-3 py-2 mt-4 text-xs font-semibold transition duration-150 ease-in-out">
                                Add/ Remove Dates
                            </button>
                            <button className="max-w-[158px] justify-center bg-grey-700 text-base-white rounded-md px-3 py-2 mt-4 text-xs font-semibold hover:bg-primary-700 transition duration-150 ease-in-out">
                                Edit my Information
                            </button>
                        </div>*/}
          </div>
        </div>
      )}
    </>
  );
};

export default MyDetails;
